export default "__VITE_ASSET__n97WNMzu__"